/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../payment/payment.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../app/shared/components/social-login-button/google/social-login-button.google.component';
import * as i6 from 'angular2-social-login/dist/auth.service';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../../app/payment/services/identification-steps.service';
const styles_SocialLoginButtonGoogleComponent:any[] = [i0.styles];
export const RenderType_SocialLoginButtonGoogleComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SocialLoginButtonGoogleComponent,data:{}});
function View_SocialLoginButtonGoogleComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'col btn btn-sm btn-gp'],['role','button'],['type','button']],[[8,'disabled',
      0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.gpLogin()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),0,'i',[['class','fa fa-google mr-sm']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(3,(null as any),['','\n'])),i1.ɵpid(131072,i2.TranslatePipe,
          [i3.TranslateService,i1.ChangeDetectorRef])],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform('PAYMENT.IDENTIFICATION.IDENTIFICATION.CONNECT_WITH_GP'));
    _ck(_v,3,0,currVal_1);
  });
}
export function View_SocialLoginButtonGoogleComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_SocialLoginButtonGoogleComponent_1)),i1.ɵdid(1,16384,(null as any),0,i4.NgIf,
      [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,
      _v) => {
    var _co:i5.SocialLoginButtonGoogleComponent = _v.component;
    const currVal_0:any = _co.allowed;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_SocialLoginButtonGoogleComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'social-login-button-google',
      ([] as any[]),(null as any),(null as any),(null as any),View_SocialLoginButtonGoogleComponent_0,
      RenderType_SocialLoginButtonGoogleComponent)),i1.ɵdid(1,49152,(null as any),
      0,i5.SocialLoginButtonGoogleComponent,[i6.AuthService,i7.ActivatedRoute,i8.IdentificationStepsService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const SocialLoginButtonGoogleComponentNgFactory:i1.ComponentFactory<i5.SocialLoginButtonGoogleComponent> = i1.ɵccf('social-login-button-google',
    i5.SocialLoginButtonGoogleComponent,View_SocialLoginButtonGoogleComponent_Host_0,
    {disabled:'disabled'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2dvb2dsZS9zb2NpYWwtbG9naW4tYnV0dG9uLmdvb2dsZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMyMDc4MDI5Mzg4L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NvY2lhbC1sb2dpbi1idXR0b24vZ29vZ2xlL3NvY2lhbC1sb2dpbi1idXR0b24uZ29vZ2xlLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2dvb2dsZS9zb2NpYWwtbG9naW4tYnV0dG9uLmdvb2dsZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9zb2NpYWwtbG9naW4tYnV0dG9uL2dvb2dsZS9zb2NpYWwtbG9naW4tYnV0dG9uLmdvb2dsZS5jb21wb25lbnQudHMuU29jaWFsTG9naW5CdXR0b25Hb29nbGVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnV0dG9uIGNsYXNzPVwiY29sIGJ0biBidG4tc20gYnRuLWdwXCIgdHlwZT1cImJ1dHRvblwiIHJvbGU9XCJidXR0b25cIlxuICAgICAgICAqbmdJZj1cImFsbG93ZWRcIlxuICAgICAgICAoY2xpY2spPVwiZ3BMb2dpbigpXCJcbiAgICAgICAgW2Rpc2FibGVkXT1cImRpc2FibGVkXCI+XG4gICAgPGkgY2xhc3M9XCJmYSBmYS1nb29nbGUgbXItc21cIj48L2k+e3tcIlBBWU1FTlQuSURFTlRJRklDQVRJT04uSURFTlRJRklDQVRJT04uQ09OTkVDVF9XSVRIX0dQXCIgfCB0cmFuc2xhdGV9fVxuPC9idXR0b24+IiwiPHNvY2lhbC1sb2dpbi1idXR0b24tZ29vZ2xlPjwvc29jaWFsLWxvZ2luLWJ1dHRvbi1nb29nbGU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFUTtNQUFBO01BQUE7SUFBQTtJQUZSO0VBQUEsZ0NBRzhCLDhDQUMxQjthQUFBO1VBQUE7TUFBa0M7VUFBQTs7SUFEOUI7SUFIUixXQUdRLFNBSFI7SUFJc0M7SUFBQTs7OztvQkFKdEM7TUFBQSxpREFBQTtNQUFBOzs7SUFDUTtJQURSLFdBQ1EsU0FEUjs7OztvQkNBQTtNQUFBO2lEQUFBLFVBQUE7TUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/$$_gendir/app/shared/components/social-login-button/google/social-login-button.google.component.ngfactory.ts